import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import { Toaster } from 'react-hot-toast'
import App from './App'
import { store } from './store'
import { ErrorBoundary } from './components/ErrorBoundary'
import { RenderNotificationsProvider } from './contexts/RenderNotificationsContext'
import { installGlobalErrorReporting } from './services/errorReporting'
import './index.css'

// Capture uncaught errors / unhandled promise rejections to the backend.
installGlobalErrorReporting()

// After a deploy, code-split chunks get new hashed names and the old files are
// removed. Vite fires `vite:preloadError` when a preloaded chunk fails to load;
// reload once to fetch the fresh bundle instead of leaving the user on a broken
// page. Guarded by a timestamp so a genuinely broken chunk can't loop forever.
window.addEventListener('vite:preloadError', () => {
  try {
    const last = Number(sessionStorage.getItem('chunkReloadAt') || 0)
    if (Date.now() - last > 10_000) {
      sessionStorage.setItem('chunkReloadAt', String(Date.now()))
      window.location.reload()
    }
  } catch {
    window.location.reload()
  }
})

// Dev helper: optionally inject a dev token into localStorage when running locally.
// Set VITE_DEV_TOKEN in your local .env to have the token automatically applied during dev.
try {
  // Vite exposes env vars as import.meta.env
  // Only set token in development mode
  if ((import.meta as any).env && (import.meta as any).env.DEV) {
    const devToken = (import.meta as any).env.VITE_DEV_TOKEN
      if (devToken) {
      try {
        localStorage.setItem('token', devToken)
        console.info('Dev token injected into localStorage')
      } catch (err) {
        // ignore
      }
    }
  }
} catch (err) {
  // ignore in production build or non-vite contexts
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
    <Provider store={store}>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <RenderNotificationsProvider>
          <App />
          <Toaster
            position="top-right"
            containerStyle={{ pointerEvents: 'none' }}
            toastOptions={{
              duration: 7000,
              success: { duration: 5500 },
              error: { duration: 9500 },
              loading: { duration: Infinity },
            }}
          />
        </RenderNotificationsProvider>
      </BrowserRouter>
    </Provider>
    </ErrorBoundary>
  </React.StrictMode>,
)
